import { addDays } from 'date-fns';

import { Day } from '@shared/base-search-bar/entities/calendar.entities';

export const CALENDAR_MS_ON_SECOND = 1000;
export const CALENDAR_HOURS_IN_ONE_DAY = 24;
export const CALENDAR_MINUTES_IN_HOURS = 60;
export const CALENDAR_ONE_DAY = CALENDAR_MS_ON_SECOND * CALENDAR_MINUTES_IN_HOURS *
  CALENDAR_MINUTES_IN_HOURS * CALENDAR_HOURS_IN_ONE_DAY;

export function differenceInDaysMapper(day?: Day): number {
  const today = new Date();
  const selectDate = day.date;
  today.setHours(0, 0, 0, 0);
  selectDate.setHours(0, 0, 0, 0);
  const differenceInTime = selectDate.getTime() - today.getTime();
  const differenceInDays = Math.round(differenceInTime) / CALENDAR_ONE_DAY;
  let numberValue = Number(differenceInDays.toFixed(0));
  if (isNegative(numberValue)) numberValue = numberValue * -1;
  return numberValue;
}

export function isTodayOrTomorrow(day?: Day): boolean {
  const today = new Date();
  const tomorrow = addDays(today, 1);
  const selection = day.date;
  today.setHours(0, 0, 0, 0);
  tomorrow.setHours(0, 0, 0, 0);
  selection.setHours(0, 0, 0, 0);
  const isToday = selection.getTime() === today.getTime();
  const isTomorrow = selection.getTime() === tomorrow.getTime();
  return isToday || isTomorrow;
}

function isNegative(numberValue: number): boolean {
  return ((numberValue = +numberValue) || 1 / numberValue) < 0;
}
